export default __webpack_public_path__ + "static/media/ellipse53N.3860efc5.svg";